export default __webpack_public_path__ + "static/media/ico_clinic_disabled.cea9a53a.svg";